export enum ActionType {
    BENIT_CENTRAL_UI_DELETE_ERROR = 'benit_central_ui_delete_error',
    BENIT_CENTRAL_UI_DELETE_ALL_ERRORS = 'benit_central_ui_delete_all_errors',
    BENIT_CENTRAL_UI_ADD_ERRORS = 'benit_central_ui_add_errors',
}
